<template>
  <div class="container-right_sidebar">
    <p class="section-label">
      {{ $t("ticket.assign") }}
    </p>

    <div class="update-label-container">
      <div style="display: flex">
        <FeatherIcon
          icon="UserIcon"
          size="20"
          class="mr-1"
        />
        <p
          v-if="!ticketStore.getLoadingState.isUpdating"
          class="label-container"
        >
          {{ $t("ticket.operator") }}: {{ data.assignName || $t('ticket.Unassigned') }}
        </p>
        <p v-else>
          <!--          {{ $t("ticket.operator") }}: {{ $t("ticket.please_wait") }}-->
          {{ $t("ticket.operator") }}: {{ data.assignName || $t('ticket.Unassigned') }}

        </p>
      </div>
      <template v-if="roleStore.canUserChangeAssignee">
        <FeatherIcon
          v-b-tooltip.hover
          :title="$t('ticket.change_assignee_ticket_required_access')"
          icon="ChevronDownIcon"
          size="24"
          style="color: #b9b9c3"
        />
      </template>
      <template v-else>
        <FeatherIcon
          icon="ChevronDownIcon"
          size="24"
          :class="
            openOperatorDropdown
              ? 'dropdown-icon-active'
              : 'dropdown-icon-inactive'
          "
          @click="
            openOperatorDropdown = !openOperatorDropdown;
            openStatusDropdown = false;
            openPriorityDropdown = false;
          "
        />
        <div
          :class="
            openOperatorDropdown
              ? 'dropdown-update-option dropdown-menu-active'
              : 'dropdown-update-option dropdown-menu-inactive'
          "
        >
          <!-- {{ ticketStore.getOptions.assignee }} -->
          <!-- Assign name: {{ data.assignName }} -->
          <p
            v-for="({ text, value }, index) in ticketStore.getOptions.assignee"
            :key="index"
            class="dropdown-update-option-item"
            :style="value === '' ?'display: none':'display:block'"
            :class="
              value === data.assignId
                ? 'select-assign__active'
                : 'select-assign__inactive'
            "
            @click="
              value !== data.assignId &&
                handleSelectDropdownItem({ operatorAssigned: value }, value)
            "
          >
            {{ text }}
          </p>
        </div>
      </template>

    </div>

    <div class="update-label-container">
      <div style="display: flex">
        <FeatherIcon
          icon="FlagIcon"
          size="20"
          class="mr-1"
        />

        <p
          v-if="!ticketStore.getLoadingState.isUpdating"
          class="label-container"
        >
          {{ $t("ticket.status") }}: {{ $t(statusLabel) }}
        </p>
        <p v-else>
          <!--          {{ $t("ticket.status") }}:{{ $t("ticket.please_wait") }}-->
          {{ $t("ticket.status") }}: {{ $t(statusLabel) }}

        </p>
      </div>
      <FeatherIcon
        icon="ChevronDownIcon"
        size="24"
        :class="
          openStatusDropdown ? 'dropdown-icon-active' : 'dropdown-icon-inactive'
        "
        @click="
          openStatusDropdown = !openStatusDropdown;
          openOperatorDropdown = false;
          openPriorityDropdown = false;
        "
      />

      <div
        :class="
          openStatusDropdown
            ? 'dropdown-update-option dropdown-menu-active'
            : 'dropdown-update-option dropdown-menu-inactive'
        "
      >
        <!-- {{ data.status }} -->
        <p
          v-for="({ text, value }, index) in statusList"
          :key="index"
          class="dropdown-update-option-item"
          :class="
            value === data.status
              ? 'select-assign__active'
              : 'select-assign__inactive'
          "
          @click="
            value !== data.status &&
              handleSelectDropdownItemStatus({ status: value }, value)
          "
        >
          {{ $t(text) }}
        </p>
      </div>
    </div>

    <div class="update-label-container">
      <div style="display: flex">
        <FeatherIcon
          icon="ArchiveIcon"
          size="20"
          class="mr-1"
        />

        <p
          v-if="!ticketStore.getLoadingState.isUpdating"
          class="label-container"
        >
          {{ $t("ticket.priority") }}: {{ $t(priorityLabel) }}
        </p>
        <p v-else>
          <!--          {{ $t("ticket.priority") }}:{{ $t("ticket.please_wait") }}-->
          {{ $t("ticket.priority") }}: {{ $t(priorityLabel) }}

        </p>
      </div>
      <FeatherIcon
        icon="ChevronDownIcon"
        size="24"
        :class="
          openPriorityDropdown ? 'dropdown-icon-active' : 'dropdown-icon-inactive'
        "
        @click="
          openPriorityDropdown = !openPriorityDropdown;
          openOperatorDropdown = false;
          openStatusDropdown = false;
        "
      />

      <div
        :class="
          openPriorityDropdown
            ? 'dropdown-update-option dropdown-menu-active'
            : 'dropdown-update-option dropdown-menu-inactive'
        "
      >
        <!-- {{ data.status }} -->
        <p
          v-for="({ text, value }, index) in priorityList"
          :key="index"
          class="dropdown-update-option-item"
          :class="
            value === data.priorityLevel
              ? 'select-assign__active'
              : 'select-assign__inactive'
          "
          @click="
            value !== data.priorityLevel &&
              handleSelectDropdownItemPriority({ priorityLevel: value }, value)
          "
        >
          {{ $t(text) }}
        </p>
      </div>
    </div>

    <!--    <div class="label-container">-->
    <!--      <FeatherIcon-->
    <!--        icon="ArchiveIcon"-->
    <!--        size="20"-->
    <!--      />-->
    <!--      <p class="label-container">-->
    <!--        {{ $t("ticket.priority") }}: {{ $t(priorityLabel) }}-->
    <!--      </p>-->
    <!--    </div>-->

    <!--      <div>-->
    <!--        <FeatherIcon-->
    <!--          icon="ChevronDownIcon"-->
    <!--          size="24"-->
    <!--          class="clickable-icon"-->
    <!--        />-->
    <!--      </div>-->

    <!--      <div-->
    <!--        class="select-option-container"-->
    <!--      >-->
    <!--        <p-->
    <!--          v-for="(status,index) in statusList"-->
    <!--          :key="index"-->
    <!--          class="select-option"-->
    <!--        >{{ status.text }}-->
    <!--        </p>-->
    <!--      </div>-->

    <!--      <b-form-select-->
    <!--        :v-model="status"-->
    <!--        size="sm"-->
    <!--        :options="statusList"-->
    <!--        value-field="value"-->
    <!--        text-field="text"-->
    <!--      />-->

    <!--      @change="() => ticketStore.updateTicketAsync({status:statusForm})"-->

    <!--      <b-dropdown-->
    <!--        size="sm"-->
    <!--        :text="statusLabel"-->
    <!--        variant="outline-primary"-->
    <!--      >-->
    <!--        <b-dropdown-item-->
    <!--          v-for="(status,index) in statusList"-->
    <!--          :key="index"-->
    <!--          @click="ticketStore.updateTicketAsync({status:status.value})"-->
    <!--        >-->
    <!--          {{ status.label }}-->
    <!--        </b-dropdown-item>-->
    <!--      </b-dropdown>-->
  </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import { BFormSelect, BTooltip } from 'bootstrap-vue'
import useTicketStore from '@/store-pinia/useTicketStore'
import useRoleStore from '@/store-pinia/useRoleStore'

export default {
  components: { BFormSelect, BTooltip },
  props: {
    status: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      default: () => ({
        assignName: 'assignName',
        assignId: 'assignId',
        status: 'status',
        priorityLevel: 'priority',
      }),
    },
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        this.openOperatorDropdown = false
        this.openStatusDropdown = false
      }
    },
  },
  setup(props) {
    const roleStore = useRoleStore()
    const openOperatorDropdown = ref(false)
    const openStatusDropdown = ref(false)
    const openPriorityDropdown = ref(false)
    const selectOperator = ref('')
    const selectStatus = ref('')

    const ticketStore = useTicketStore()
    const priorityLabel = computed(() => {
      let result = ''
      if (props.data.priorityLevel === 1) result = 'ticket.low'
      if (props.data.priorityLevel === 2) result = 'ticket.high'
      if (props.data.priorityLevel === 3) result = 'ticket.medium'
      if (props.data.priorityLevel === 4) result = 'ticket.urgent'
      if (props.data.priorityLevel === 0) result = 'ticket.unassigned'
      return result
    })
    const statusLabel = computed(() => {
      let result = ''
      if (props.data.status === 1) result = 'ticket.open'
      if (props.data.status === 2) result = 'ticket.resolved'
      if (props.data.status === 3) result = 'ticket.pending'
      return result
    })
    const statusList = [
      {
        text: 'ticket.open',
        value: 1,
      },
      {
        text: 'ticket.resolved',
        value: 2,
      },
      {
        text: 'ticket.pending',
        value: 3,
      },
    ]
    const priorityList = [
      {
        text: 'ticket.low',
        value: 1,
      },
      {
        text: 'ticket.high',
        value: 2,
      },
      {
        text: 'ticket.medium',
        value: 3,
      },
      {
        text: 'ticket.urgent',
        value: 4,
      },
    ]
    const statusForm = ref(props.data.priorityLevel)

    function handleSelectDropdownItem(payload, operatorName) {
      selectOperator.value = operatorName
      // console.log('testing selectOperator', selectOperator.value)
      ticketStore.updateTicketAsync(payload)
      openOperatorDropdown.value = false
      openStatusDropdown.value = false
      openPriorityDropdown.value = false
    }

    function handleSelectDropdownItemStatus(payload, statusName) {
      selectStatus.value = statusName
      // console.log('testing selectStatus', selectStatus.value)
      ticketStore.updateTicketAsync(payload)
      openOperatorDropdown.value = false
      openStatusDropdown.value = false
      openPriorityDropdown.value = false
    }

    function handleSelectDropdownItemPriority(payload, priorityName) {
      selectStatus.value = priorityName
      // console.log('testing selectStatus', selectStatus.value)
      ticketStore.updateTicketAsync(payload)
      openOperatorDropdown.value = false
      openStatusDropdown.value = false
      openPriorityDropdown.value = false
    }

    return {
      statusForm,
      ticketStore,
      priorityLabel,
      statusLabel,
      statusList,
      openStatusDropdown,
      openOperatorDropdown,
      openPriorityDropdown,
      selectOperator,
      selectStatus,
      priorityList,
      roleStore,
      handleSelectDropdownItem,
      handleSelectDropdownItemStatus,
      handleSelectDropdownItemPriority,

    }
  },
}
</script>

<style lang="scss" scoped>
.label-container {
  //font-weight: bold;
}

.clickable-icon {
  cursor: pointer;
}

.header-subtitle {
  font-size: 0.85em;
  color: gray;
}

.label-container {
  display: flex;
  gap: 1em;
}

.update-label-container {
  @extend .label-container;
  justify-content: space-between;
  position: relative;
}

.select-container {
  position: relative;
  display: flex;
  justify-content: space-between;
}

.select-option-container {
  position: absolute;
  width: 100%;
  top: 100%;
  background: white;
  box-shadow: 0 5px 25px rgba(47, 47, 47, 0.1);

  //opacity: 0;
  //visibility: hidden;
  transition: all 0.3s ease-in-out;

  &:hover {
    //opacity: 1;
    //visibility: visible;
  }
}

.dropdown-update-option {
  z-index: 1;
  position: absolute;
  width: 100%;
  top: 100%;
  background: white;
  box-shadow: 0 5px 25px rgba(47, 47, 47, 0.1);
  transition: all 0.3s ease-in-out;

  .dropdown-update-option-item {
    margin: unset;
    padding: 0.5em 1em;
    cursor: pointer;

    &:hover {
      background: #b876af;
      color: white;
    }
  }
}

.dropdown-menu-active {
  opacity: 1;
  visibility: visible;
}

.dropdown-menu-inactive {
  opacity: 0;
  visibility: hidden;
}

.select-option {
  margin: 0;
  padding: 0.5em 1em;

  &:hover {
    cursor: pointer;
    background-color: #b366a9;
    color: white;
  }
}

.dropdown-icon {
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.dropdown-icon-active {
  @extend .dropdown-icon;
  transform: rotate(180deg);
}

.dropdown-icon-inactive {
  @extend .dropdown-icon;
  transform: rotate(0deg);
}

.container-right_sidebar {
}

.select-assign {
  display: flex;
  cursor: pointer;
  align-items: center;
}

.select-assign__active {
  @extend .select-assign;
  //background: #9f6096;
  background: #F2F0F7;
  color:#9f6096;
  // padding-left: 1rem !important;
  cursor: not-allowed !important;
  //color: #fff;
  //@hover:{
  //  background: #F2F0F7;
  //  color:#9f6096;
  //}
}

.select-assign__inactive {
  @extend .select-assign;

  &:hover {
    background: whitesmoke;
  }
}

// element.style {
//   border: 1px solid #9f6096;
// }

[dir] .dropdown-update-option[data-v-261af446] {
  background: white;
  box-shadow: 0 5px 25px rgb(47 47 47 / 10%);
  border: 1px solid #9f6096;
  max-height: 200px;
  overflow-y: scroll;

}
</style>
